<template>
  <div class="sidebar">
    <h2 class="logo">🌿 植物后台</h2>
    <ul class="menu">
      <li v-for="item in menus" :key="item.path">
        <router-link :to="item.path" class="menu-item" active-class="active">
          {{ item.name }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script setup>
const menus = [
  { name: '仪表盘', path: '/index' },
  { name: '首页管理', path: '/home' },
  { name: '花卉百科', path: '/baike' },
  { name: '商城管理', path: '/mall' },
  { name: '用户管理', path: '/user' }
]
</script>

<style scoped>
.sidebar {
  width: 220px;
  background: #1e1e2f;
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 1600px;
}
.logo {
  font-size: 20px;
  text-align: center;
  padding: 20px 0;
  border-bottom: 1px solid #444;
}
.menu {
  list-style: none;
  padding: 0;
  margin: 0;
  height: auto;
}
.menu-item {
  display: block;
  padding: 12px 20px;
  color: #ccc;
  text-decoration: none;
}
.menu-item:hover,
.active {
  background: #2f2f4f;
  color: #fff;
}
</style>
